/* eslint-disable padding-line-between-statements */
/* eslint-disable unicorn/filename-case */
import React, { useCallback, useContext,useState, useEffect } from 'react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
import metadata from './TWIAPhoneComponent.metadata.json5';
import messages from '../../addressMessages.messages';

function TWIAPhoneComponent(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { accountHolderVM, updateSubmissionVM, isPerson, showErrors, findInvalidComponent, onValidate, contactUpdated, setContactUpdated, 
        homePhoneValidationMessage, setHomePhoneValidationMessage, 
        workPhoneValidationMessage, setWorkPhoneValidationMessage, 
        cellPhoneValidationMessage, setCellPhoneValidationMessage } = props;
    const [accountVM, updateAccountVM] = useState(accountHolderVM);
    const [primaryPhone, setPrimaryPhone] = useState('');
    const [homePhoneMessage, setHomePhoneMessage] = useState([]);
    const [workPhoneMessage, setWorkPhoneMessage] = useState([]);
    const [cellPhoneMessage, setCellPhoneMessage] = useState([]);
    const [faxMessage, setFaxMessage] = useState([]);
    const isPhoneNumberValid = (phone) => /^[2-9]\(?([0-9]{2})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(phone);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('TWIAPhoneComponent');
    

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TWIAPhoneComponent');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'TWIAPhoneComponent');
    }, [findInvalidComponent, isComponentValid])

    const updatePrimaryPhoneFields = () => {
        let primaryPhoneType = '';
        const code = _.get(accountHolderVM, 'primaryPhoneType.value.code');
        const cellNumber = _.get(accountHolderVM, 'cellNumber.value')
        const workNumber = _.get(accountHolderVM, 'workNumber.value')
        // DE16030
        if (code === undefined) {
            if (!isPerson) {
                primaryPhoneType = 'workNumber';
                _.set(accountHolderVM, 'primaryPhoneType.value', 'work');
            } else {
                primaryPhoneType = 'homeNumber';
                _.set(accountHolderVM, 'primaryPhoneType.value', 'home');
            }
            if(cellNumber != null) {
                primaryPhoneType = 'cellNumber';
                _.set(accountHolderVM, 'primaryPhoneType.value', 'mobile');
            } else if(workNumber != null) {
                primaryPhoneType = 'workNumber';
                _.set(accountHolderVM, 'primaryPhoneType.value', 'work');
            } else {
                primaryPhoneType = 'homeNumber';
                _.set(accountHolderVM, 'primaryPhoneType.value', 'home');
            }
           
            // DE16727
            updateAccountVM(accountHolderVM);
            setPrimaryPhone(primaryPhoneType);
            return ;
        }

        switch (code) {
            case 'work':
                primaryPhoneType = 'workNumber';
                break;
            case 'home':
                primaryPhoneType = 'homeNumber';
                break;
            case 'mobile':
                primaryPhoneType = 'cellNumber';
                break;
            default:
                break;
        }

        updateAccountVM(accountHolderVM);
        setPrimaryPhone(primaryPhoneType);
    };

    
    
    useEffect(() => {
        if(contactUpdated){
            updatePrimaryPhoneFields();
            if(setContactUpdated){
                setContactUpdated(false)
            }
        } else {
            updatePrimaryPhoneFields(); 
        }
        // DE16727 When Account type is Personal; setting default value to 'HomeNumber'
        // if(isPerson) { 
        //     _.set(accountHolderVM, 'primaryPhoneType.value', 'home');
        //     updateAccountVM(accountHolderVM);
        //     setPrimaryPhone('homeNumber');
        // }
    }, [contactUpdated, setContactUpdated, updatePrimaryPhoneFields]);
    
    const validateNumber = useCallback((event ,fullValue) => {
        const { model, value } = fullValue;
        if (value && value.match(/[a-z A-Z]/g)) {
            return false;
        }
        if (value.length === 3 || value.length === 7) {
            value += "-"
        }
        if (model === 'workNumber') {
            setWorkPhoneMessage([]);
            setWorkPhoneValidationMessage([]);
            if (!value && model !== primaryPhone) {
                setWorkPhoneMessage([])
            }
            else if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {
                setWorkPhoneMessage([translator(messages.phoneValidationMessage)])
            }
            setWorkPhoneMessage(accountVM.workNumber.aspects.validationMessages);
        }
        if (model === 'homeNumber') {
            setHomePhoneMessage([]);
            setHomePhoneValidationMessage([]);
            if (!value && model !== primaryPhone) {
                setHomePhoneMessage([])
            }
            else if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {
                setHomePhoneMessage([translator(messages.phoneValidationMessage)])
            }
            setHomePhoneMessage(accountVM.homeNumber.aspects.validationMessages);
        }
        if (model === 'cellNumber') {
            setCellPhoneMessage([]);
            setCellPhoneValidationMessage([]);
            if (!value && model !== primaryPhone) {
                setCellPhoneMessage([])
            }
            else if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {
                setCellPhoneMessage([translator(messages.phoneValidationMessage)])
            }
            setCellPhoneMessage(accountVM.cellNumber.aspects.validationMessages);
        }
        updateAccountVM(accountVM)
        updateSubmissionVM(accountVM);

    },[]);
    
    // DE16014 //DE16033
    const validateFaxNumber = useCallback((event, fullValue) => {
        const { model, value } = fullValue;
        if (value && value.match(/[a-z A-Z]/g)) {
            return false;
        }
        if (value.length === 3 || value.length === 7) {
            value += "-"
        }
        if (model === 'cellNumber') {
            setFaxMessage([]);
            if (!value && model !== primaryPhone) {
                setFaxMessage([])
            }
            else if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {
                setFaxMessage([translator(messages.phoneValidationMessage)])
            }
        }
        updateAccountVM(accountVM)
        updateSubmissionVM(accountVM);
    },[])
    
    const changeRequiredNumber = useCallback(
        (value, path) => {
            _.set(accountVM, path, value);
            updatePrimaryPhoneFields();
            updateAccountVM(accountVM);
            updateSubmissionVM(accountVM);
        },
        [accountVM, updateSubmissionVM]
    );
    
    // DE16033
    const phoneNumberValidationMessage = useCallback((phoneType,phoneMessage)=>
        _.isEmpty(phoneMessage) && primaryPhone === phoneType &&
         _.get(accountHolderVM,`${phoneType}.value`)===""? 
         [translator(messages.required)] : phoneMessage,[accountHolderVM, primaryPhone, translator])

    const writeValue = useCallback(
        (value, path) => {
            _.set(accountVM, path, value);
            updateSubmissionVM(accountVM);
        }, [accountVM, updateSubmissionVM]
    );

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        primaryNumber: {
            // defaultValue: isPerson ? 'home' : 'workNumber',
            onValueChange: changeRequiredNumber
        },
        workPhoneNumber: {
            required: !isPerson || primaryPhone === 'workNumber',
            showRequired: primaryPhone === 'workNumber',
            onBlur: validateNumber,
            validationMessages: !_.isEmpty(workPhoneValidationMessage) ? workPhoneValidationMessage : phoneNumberValidationMessage('workNumber', workPhoneMessage)
        },
        homePhoneNumber: {
            visible: isPerson,
            required: primaryPhone === 'homeNumber',
            showRequired: primaryPhone === 'homeNumber',
            onBlur: validateNumber,
            validationMessages: !_.isEmpty(homePhoneValidationMessage) ? homePhoneValidationMessage: phoneNumberValidationMessage('homeNumber',homePhoneMessage)
        },
        cellPhoneNumber: {
            visible: isPerson,
            required: primaryPhone === 'cellNumber',
            showRequired: primaryPhone === 'cellNumber',
            onBlur: validateNumber,
            validationMessages: !_.isEmpty(cellPhoneValidationMessage) ? cellPhoneValidationMessage : phoneNumberValidationMessage('cellNumber', cellPhoneMessage)
        },
        faxNumber: {
            visible: !isPerson,
            onBlur: validateFaxNumber,
            validationMessages: faxMessage
        }
    }
    const resolvers = {
        resolveClassNameMap: wizardStyles,
    }

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={accountHolderVM}
                overrideProps={overrideProps}
                onValueChange={writeValue}
                onModelChange={updateAccountVM}
                onValidationChange={setComponentValidation}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                showErrors={showErrors}
        />
    )
}

TWIAPhoneComponent.defaultProps = {
    homePhoneValidationMessage: [],
    workPhoneValidationMessage: [],
    cellPhoneValidationMessage: [],
    setWorkPhoneValidationMessage: () => {},
    setCellPhoneValidationMessage: () => {},
    setHomePhoneValidationMessage: () => {}
};

export default TWIAPhoneComponent